import {HubspotApiService} from "@/services/hubspot/api";

export const $hubspot = new HubspotApiService();